import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { APIErrorResponse, ResearchVisitEvent } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { QUERY_KEYS } from '@/constants'

export type UsePostCloneEventProps = {
  id: number
}

export const usePostCloneEvent = ({
  id,
}: UsePostCloneEventProps): UseMutationResult<
  ResearchVisitEvent,
  APIErrorResponse
> => {
  const client = useApiClient()

  const queryClient = useQueryClient()

  return useMutation(
    () =>
      client
        .post(`plannings/events/manager/${id}/clone_event/`)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(QUERY_KEYS.PLANNING_EVENTS_MANAGER)
        await queryClient.invalidateQueries(QUERY_KEYS.PROJECT_PLANNING_EVENTS)
        await queryClient.invalidateQueries(QUERY_KEYS.PLANNING_EVENTS_FILTERED)
        await queryClient.invalidateQueries(QUERY_KEYS.PLANNING_EVENTS)
      },
    }
  )
}
